<div
  [formGroup]="form"
  class="form-container"
>
  <div class="view">
    <div class="p-grid">
      <div class="p-col-12 p-lg-6 form-panel">
        @if (user?.ldap) {
          <div class="ldap-information">
            <i class="icon-info-icon information-icon"></i>
            <span class="information-text">
              {{ 'library.user_card.settings.information.ldap' | translate }}
              <app-link [source]="user.ldap"></app-link>
            </span>
          </div>
        }
        @if (user?.entraId) {
          <div class="ldap-information">
            <i class="icon-info-icon information-icon"></i>
            <span class="information-text">
              {{ 'library.user_card.settings.information.entra_id' | translate }}
              <app-link [source]="user.entraId"></app-link>
            </span>
          </div>
        }
        <div class="form-control-container">
          <app-form-control-label [control]="form.get('general.firstName')">
            {{ 'library.user_card.settings.form.first_name.label' | translate }}:
          </app-form-control-label>
          <input
            [appApiErrors]="generalFormErrors.firstName"
            [formControl]="form.get('general.firstName')"
            appInput
            data-qa="user-card-settings-first-name"
            type="text"
          >
          <app-form-control-error [control]="form.get('general.firstName')"></app-form-control-error>
        </div>
        <div class="form-control-container">
          <app-form-control-label [control]="form.get('general.lastName')">
            {{ 'library.user_card.settings.form.last_name.label' | translate }}:
          </app-form-control-label>
          <input
            [appApiErrors]="generalFormErrors.lastName"
            [formControl]="form.get('general.lastName')"
            appInput
            data-qa="user-card-settings-last-name"
            type="text"
          >
          <app-form-control-error [control]="form.get('general.lastName')"></app-form-control-error>
        </div>
        <div class="form-control-container">
          <app-form-control-label [control]="form.get('general.email')">
            {{ 'library.user_card.settings.form.email.label' | translate }}:
          </app-form-control-label>
          <input
            [appApiErrors]="generalFormErrors.email"
            [formControl]="form.get('general.email')"
            appInput
            data-qa="user-card-settings-email"
            type="text"
          >
          <app-form-control-error [control]="form.get('general.email')"></app-form-control-error>
        </div>
        <div class="form-control-container">
          <app-form-control-label [control]="form.get('general.username')">
            {{ 'library.user_card.settings.form.username.label' | translate }}:
          </app-form-control-label>
          <input
            [appApiErrors]="generalFormErrors.username"
            [formControl]="form.get('general.username')"
            appInput
            data-qa="user-card-settings-username"
            type="text"
          >
          <app-form-control-error [control]="form.get('general.username')"></app-form-control-error>
        </div>
      </div>
      <div class="p-col-12 p-lg-6 form-panel">
        <div class="form-separator lg-hidden"></div>
        @if (form.get('self').enabled) {
          <div class="form-control-container">
            <app-form-control-label [control]="form.get('self.colorMode')">
              {{ 'library.user_card.settings.form.color_mode.label' | translate }}:
            </app-form-control-label>
            <app-dropdown
              [formControl]="form.get('self.colorMode')"
              [options]="colorModeOptions"
              data-qa="user-card-settings-theme-dropdown"
            >
            </app-dropdown>
            <app-form-control-error [control]="form.get('self.colorMode')"></app-form-control-error>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="view align-center">
    <button
      [disabled]="requestPending"
      [submitButton]="form"
      (click)="submit()"
      data-qa="user-card-settings-submit-button"
      type="button"
      class="proget-button text-only primary-button"
    >
      {{ 'button.submit.label' | translate }}
    </button>
  </div>
</div>
